import React from "react";
import {BaseEmailPage} from "./BaseEmailPage";
import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../HomePage/HomePage";
import {BaseModal} from "../../components/BaseModal";



export const EmailModal = (props) => {
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        background: 'white',
        boxShadow: 24,
        p: 4,
        borderRadius: '20px',
        width: isTabletOrMobile ? '' : '600px',
        height: '646px'
    };
    return (
        <BaseModal
            isOpen={props.isOpen}
            setIsOpen={() => props.setIsOpen(null)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            style={style}
        >
            <BaseEmailPage {...props}/>
        </BaseModal>
    )
}